import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { OrderHistorySalesService } from './order-history-sales.service';
import { OrderData } from './order-history-sales.model';

export class OrderHistorySalesDataSource implements DataSource<OrderData> {

  private dataSubject = new BehaviorSubject<OrderData[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private orderHistoryService: OrderHistorySalesService) {}

  connect(collectionViewer: CollectionViewer): Observable<OrderData[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadOrderHistorySales(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'orderSequence',
    sortDirection: string = 'asc',
    filter: string = '',
    filterType: string
  ) {

    this.loadingSubject.next(true);

    this.orderHistoryService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter,
        filterType
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.order_history_sales);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
